import { gql } from "@apollo/client";
import {
  CustomerNoNestingFragment,
  LocationNoNestingFragment,
  PaginatedListMetaNoNestingFragment,
  PaymentNoNestingFragment,
  ProformaCustomerDetailsDeepNestingFragment,
  ProformaDataDeepNestingFragment,
  ProformaItemDeepNestingFragment,
  SaleAdjustmentNoNestingFragment,
  SaleFragment,
  SaleLineItemNoNestingFragment,
  StaffNoNestingFragment,
  TerminalNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const QUERY_SALE_PROFORMAS = gql`
  ${ProformaDataDeepNestingFragment}
  ${ProformaCustomerDetailsDeepNestingFragment}
  ${ProformaItemDeepNestingFragment}
  ${SaleFragment}
  ${PaymentNoNestingFragment}
  ${SaleLineItemNoNestingFragment}
  ${LocationNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  ${PaginatedListMetaNoNestingFragment}
  query saleProformas($options: SaleProformaListOptions) {
    saleProformas(options: $options) {
      items {
        saleId
        updatedAt
        id
        identifier
        deletedAt
        createdAt
        location {
          ...LocationNoNesting
        }
        data {
          ...ProformaDataDeepNesting
        }
        sale {
          ...Sale
          isReturn
          returnForId
          lineItems {
            ...SaleLineItemNoNesting
            adjustments {
              ...SaleAdjustmentNoNesting
            }
          }
        }
      }
      meta {
        ...PaginatedListMetaNoNesting
      }
    }
  }
`;

export const QUERY_PROFORMA_BY_SALE_ID = gql`
  ${ProformaDataDeepNestingFragment}
  ${ProformaCustomerDetailsDeepNestingFragment}
  ${ProformaItemDeepNestingFragment}
  ${SaleFragment}
  ${PaymentNoNestingFragment}
  ${SaleLineItemNoNestingFragment}
  ${LocationNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  query proformaBySaleId($saleId: ID!) {
    proformaBySaleId(saleId: $saleId) {
      saleId
      updatedAt
      id
      identifier
      deletedAt
      createdAt
      location {
        ...LocationNoNesting
      }
      data {
        ...ProformaDataDeepNesting
      }
      sale {
        ...Sale
        isReturn
        returnForId
        lineItems {
          ...SaleLineItemNoNesting
          adjustments {
            ...SaleAdjustmentNoNesting
          }
        }
      }
    }
  }
`;

export const QUERY_SALE_PROFORMA = gql`
  ${ProformaDataDeepNestingFragment}
  ${ProformaCustomerDetailsDeepNestingFragment}
  ${ProformaItemDeepNestingFragment}
  ${SaleFragment}
  ${PaymentNoNestingFragment}
  ${SaleLineItemNoNestingFragment}
  ${LocationNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  query saleProforma($id: ID!) {
    saleProforma(id: $id) {
      saleId
      updatedAt
      id
      identifier
      deletedAt
      createdAt
      data {
        ...ProformaDataDeepNesting
      }
      location {
        ...LocationNoNesting
      }
      sale {
        ...Sale
        isReturn
        returnForId
        lineItems {
          ...SaleLineItemNoNesting
          adjustments {
            ...SaleAdjustmentNoNesting
          }
        }
      }
    }
  }
`;

export const MUTATION_CONVERT_PROFORMA_TO_SALE = gql`
  ${SaleFragment}
  ${PaymentNoNestingFragment}
  ${SaleLineItemNoNestingFragment}
  ${LocationNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  mutation convertProformaToSale(
    $id: ID!
    $options: ConvertProformaToSaleOptions
  ) {
    convertProformaToSale(id: $id, options: $options) {
      ...Sale
      isReturn
      returnForId
      lineItems {
        ...SaleLineItemNoNesting
        adjustments {
          ...SaleAdjustmentNoNesting
        }
      }
    }
  }
`;
